module.exports = __webpack_public_path__ + "@/assets/img/IPP_Logo@2x.2ec9d5f6.png";